module.exports = __webpack_public_path__ + "static/media/two-factor-authentication-2fa-icon.33fb8ae1.svg";